<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import TeamCreateModal from "@/components/Header/TeamCreateModal";

export default {
  // Sub-components included in this component
  components: {
    TeamCreateModal,
  },

  // When the team selector is created, fetch the teams
  async created() {
    await this.getTeams();
  },

  computed: {
    // Map state values into this component
    ...mapGetters(["activeTeam", "can"]),
    ...mapState(["teams", "activeTeamId"]),
  },

  methods: {
    // Switch to a team that is selected in the dropdown
    switchTeams(teamId) {
      // If passed in team ID to switch to is already active, then return
      if (teamId === this.activeTeamId) {
        return;
      }

      // Change the active team ID in the state
      this.setActiveTeamId(teamId);

      // Ensure that the user has access to the current page, and if not,
      // reroute to the fallback
      let access = this.$route.meta.access;
      if (access) {
        if (!this.can[access.entity][access.action]) {
          this.$router.replace(access.fallback || "/");
        }
      }
    },

    // Other state actions
    ...mapMutations(["setActiveTeamId"]),
    ...mapActions(["getTeams"]),
  },

  filters: {
    truncate(label) {
      if (label.length >= 17) {
        return label.substr(0, 13) + "...";
      } else {
        return label;
      }
    },
  },
};
</script>

<template>
  <b-navbar-nav>
    <b-nav-item-dropdown id="team-selector">
      <template v-slot:button-content>
        <span :title="'#' + activeTeam.handle">
          #{{ activeTeam.handle | truncate }}
        </span>
      </template>
      <b-dropdown-item
        :active="activeTeamId === team.id"
        @click="switchTeams(team.id)"
        v-for="(team, index) in Object.values(teams).sort((a, b) =>
          a.handle > b.handle ? 1 : -1
        )"
        :key="index"
      >
        #{{ team.handle }}
      </b-dropdown-item>

      <b-dropdown-divider />
      <b-dropdown-item v-b-modal.create-team-modal>
        Create New Team
      </b-dropdown-item>
      <TeamCreateModal modal-id="create-team-modal" />
    </b-nav-item-dropdown>
  </b-navbar-nav>
</template>

<style>
#team-selector ul {
  max-height: 90vh;
  overflow-y: scroll;
}
</style>
